module.exports = __webpack_public_path__ + "media/img/missinlovers-de5de6f9.jpg";